import { Badge } from "@/components/ui/badge";
import { TrendingDown } from "lucide-react";
import { exportCSV } from "@/lib/exports";
import { ExportBtn } from "@/components/dashboard/ExportBtn";

export const ModelBreakdown = ({ breakdown }) => {
  if (!breakdown) return <div className="h-96 bg-[#1E293B] border border-[#334155] rounded-lg animate-pulse" />;
  const totals = breakdown.table.reduce((t, m) => ({
    in_stock: t.in_stock + (m.in_stock || 0), sold_90d: t.sold_90d + (m.sold_90d || 0), sold_total: t.sold_total + (m.sold_total || 0),
  }), { in_stock: 0, sold_90d: 0, sold_total: 0 });
  return (
    <div data-testid="model-breakdown-table" className="bg-[#1E293B] border border-[#334155] rounded-lg p-5">
      <h3 className="text-lg font-semibold mb-1 flex items-center justify-between" style={{ fontFamily: "Outfit, sans-serif" }}>
        <span>Model Breakdown</span>
        <ExportBtn onCSV={() => exportCSV(breakdown.table, "model-breakdown")} />
      </h3>
      <p className="text-xs text-slate-400 mb-3">Stock vs sales velocity — slow movers flagged.</p>
      <div className="overflow-auto max-h-[480px]">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-[#1E293B] z-10">
            <tr className="text-left text-xs uppercase tracking-widest text-slate-400 border-b border-[#334155]">
              <th className="pb-2 pr-2">Model</th>
              <th className="pb-2 pr-2 text-right">Stock</th>
              <th className="pb-2 pr-2 text-right">Sold 90d</th>
              <th className="pb-2 pr-2 text-right">Sold Total</th>
              <th className="pb-2 pr-2 text-right">Avg Age</th>
              <th className="pb-2"></th>
            </tr>
          </thead>
          <tbody>
            {breakdown.table.map((m, i) => (
              <tr key={m.model} data-testid={`model-row-${i}`} className="border-b border-slate-800/60 hover:bg-slate-800/40 transition-colors">
                <td className="py-2 pr-2 text-slate-200">{m.model} {m.code && <span className="text-slate-500 text-xs font-mono">({m.code})</span>}</td>
                <td className="py-2 pr-2 text-right font-mono text-amber-400">{m.in_stock}</td>
                <td className="py-2 pr-2 text-right font-mono">{m.sold_90d}</td>
                <td className="py-2 pr-2 text-right font-mono text-slate-400">{m.sold_total}</td>
                <td className={`py-2 pr-2 text-right font-mono ${m.avg_stock_age > 90 ? "text-rose-400" : m.avg_stock_age > 60 ? "text-orange-400" : "text-slate-300"}`}>
                  {m.in_stock > 0 ? `${m.avg_stock_age}d` : "—"}
                </td>
                <td className="py-2">
                  {m.slow_mover && (
                    <Badge data-testid={`slow-mover-badge-${i}`} variant="outline" className="border-rose-500/50 text-rose-400 text-[10px] gap-1">
                      <TrendingDown className="h-3 w-3" /> Slow
                    </Badge>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr data-testid="model-breakdown-total-row" className="border-t-2 border-[#334155] font-bold">
              <td className="py-2.5 pr-2 text-slate-100">Total ({breakdown.table.length} models)</td>
              <td className="py-2.5 pr-2 text-right font-mono text-amber-400">{totals.in_stock}</td>
              <td className="py-2.5 pr-2 text-right font-mono text-slate-100">{totals.sold_90d}</td>
              <td className="py-2.5 pr-2 text-right font-mono text-slate-100">{totals.sold_total}</td>
              <td className="py-2.5"></td>
              <td className="py-2.5"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};
